import {
  Box,
  Button,
  Grid,
  Link,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { Container } from '@mui/system';

import InformationSubMenu from '@/components/nav/InformationSubMenu';
import Hidden from '@/components/ui/TzoHidden';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Index = () => {
  // const [open, setOpen] = useState(false);
  return (
    <AppLayout
      meta={
        <Meta
          title="Form W-2 State Filing Requirements Guide | TaxZerone"
          description="Discover state filing requirements for Form W-2. Learn about state-specific rules. TaxZerone offers easy, accurate, and secure state e-filing solutions."
          keywords=""
          canonical="form-w2-state-filing/"
          jsonLdPricing="0.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="2183"
          ogShareImg="assets/images/information-share-img.png"
        />
      }
    >
      <InformationSubMenu />
      {/* <ComingSoonPopup open={open} setOpen={setOpen} /> */}
      <Container maxWidth="lg" sx={{ mt: 3, mb: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 0, lg: 0, xl: 0 },
              justifyContent: 'center',
            }}
          >
            <Box
              component="div"
              sx={{ mt: { xs: 2, sm: 4, md: 5 }, mb: { xs: 2, sm: 4, md: 5 } }}
            >
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                {' '}
                <span className="highlight-container">
                  <span className="highlight">W-2 State Filing</span>
                </span>{' '}
                Requirements: Everything You Need to Know
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Ensure Compliance with W-2 State Requirements Across the U.S.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                }}
              >
                Stay up-to-date with state-specific W-2 filing regulations and
                avoid penalties.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Button
                  variant="contained"
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w2-state-filing`}
                  sx={{
                    mr: { xs: 0, md: 4 },
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  File Form W-2
                </Button>
              </Stack>
            </Box>
          </Box>
          <Hidden lgDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
              className="state-filing-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/w2-state-requirement-img.webp"
                  className="img-responsive-banner-state"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/w2-state-requirement-img.png"
                  className="img-responsive-banner-state"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/w2-state-requirement-img.png"
                  alt="W-2 State Requirements: Everything You Need to Know"
                  className="img-responsive-banner-state"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden lgUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
              className="state-filing-bg"
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/w2-state-requirement-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/w2-state-requirement-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/w2-state-requirement-img-sm.png"
                  alt="W-2 State Requirements: Everything You Need to Know"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%', py: 2, px: 4 }}>
              <Typography
                variant="h3"
                sx={{
                  lineHeight: 1.5,
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                }}
              >
                Filing W-2 forms is essential for every employer, but each state
                has its own set of rules and deadlines. Understanding these
                requirements ensures that you remain compliant with both federal
                and state laws. Our platform makes the process easy, helping you
                stay ahead of the deadlines and meet all state-specific W-2
                filing regulations.
              </Typography>
            </Box>
            {/* <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              <Button
                size="large"
                variant="contained"
                href="/pricing/#informationreturns"
                sx={{
                  boxShadow: 'none',
                  borderRadius: 2,
                  mb: 0.5,
                  textTransform: 'none',
                  backgroundColor: '#fff',
                  color: '#0a7581',
                  '&:hover, &:focus, &:active': {
                    color: '#fff',
                    backgroundColor: '#172b6b',
                  },
                }}
              >
                See Pricing
              </Button>
              <Typography
                variant="body2"
                sx={{ mt: 0, mb: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                For your return volume
              </Typography>
            </Box> */}
          </Stack>
        </Container>
      </Grid>

      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          sx={{ my: { xs: 2, sm: 6, md: 8, justifyContent: 'center' } }}
          className="MuiGrid-root-width"
        >
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Why Are State Requirements Important?
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                px: 3,
                pt: 5,
                pb: 5,
                textAlign: 'center',
                borderWidth: 3,
                borderColor: '#8492c0',
                borderRadius: 10,
                minHeight: '100%',
                backgroundColor: '#efefef',
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  width: 90,
                  height: 90,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mx: 'auto',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/compliance-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/compliance-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/compliance-icon.png"
                    alt="Compliance"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                Compliance
              </Typography>
              <Typography variant="body1">
                Each state has unique requirements for W-2 forms, and
                understanding them is crucial to avoid penalties.
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                px: 3,
                pt: 5,
                pb: 5,
                textAlign: 'center',
                borderWidth: 3,
                borderColor: '#76ce97',
                borderRadius: 10,
                minHeight: '100%',
                backgroundColor: '#efefef',
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  width: 90,
                  height: 90,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mx: 'auto',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/employee-records-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/employee-records-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/employee-records-icon.png"
                    alt="Employee Records"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                Employee Records
              </Typography>
              <Typography variant="body1">
                Accurate W-2 forms ensure that your employees&apos; tax records
                are correct, affecting their tax returns and potential refunds.
              </Typography>
            </Paper>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Paper
              variant="outlined"
              sx={{
                px: 3,
                pt: 5,
                pb: 5,
                textAlign: 'center',
                borderWidth: 3,
                borderColor: '#8492c0',
                borderRadius: 10,
                minHeight: '100%',
                backgroundColor: '#efefef',
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#fff',
                  borderRadius: '50%',
                  width: 90,
                  height: 90,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  mx: 'auto',
                }}
              >
                <picture style={{ width: 60, height: 60 }}>
                  <source
                    srcSet="/assets/images/state-taxes-icon.webp"
                    width={60}
                    height={60}
                  />
                  <source
                    srcSet="/assets/images/state-taxes-icon.png"
                    width={60}
                    height={60}
                  />
                  <img
                    src="/assets/images/state-taxes-icon.png"
                    alt="State-Specific Taxes"
                    loading="lazy"
                    width={60}
                    height={60}
                  />
                </picture>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  fontWeight: 600,
                  my: 3,
                }}
              >
                State-Specific Taxes
              </Typography>
              <Typography variant="body1">
                Some states have additional taxes that must be reported on the
                W-2 form, making it vital to know your state’s regulations.
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',

          pb: 0,
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          // className="gradient-bg"
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 3,
              textAlign: 'center',
              lineHeight: 1.5,
            }}
          >
            State-by-State W-2 Filing Requirements
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', px: 16, mb: 2 }}
          >
            Each U.S. state has its own unique requirements for filing W-2
            forms, including deadlines, specific information, and electronic
            filing mandates. Click the state name to learn more about its W-2
            filing requirements.
          </Typography>
          <Box component="div" sx={{ mb: 2 }}>
            <TableContainer sx={{ border: '1px solid #828282' }}>
              <Table sx={{}} aria-label="Due Date Chart">
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#ccc' }}>
                    <TableCell
                      sx={{ color: '#444', fontWeight: 600, width: 300 }}
                    >
                      State
                    </TableCell>

                    <TableCell
                      sx={{ color: '#444', fontWeight: 600, width: 300 }}
                    >
                      Deadline
                    </TableCell>
                    <TableCell
                      sx={{ color: '#444', fontWeight: 600, width: 300 }}
                    >
                      Additional Information
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/alabama-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Alabama (AL)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Alaska (AK)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/arizona-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Arizona (AZ)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/arkansas-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Arkansas (AR)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>California (CA)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>
                      State Tax Exists but No Filing Required
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/colorado-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Colorado (CO)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/connecticut-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Connecticut (CT)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/delaware-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Delaware (DE)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/district-of-columbia-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        District of Columbia (DC)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Florida (FL)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/georgia-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Georgia (GA)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/hawaii-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Hawaii (HI)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/idaho-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Idaho (ID)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/illinois-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Illinois (IL)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/indiana-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Indiana (IN)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/iowa-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Iowa (IA)
                      </Link>
                    </TableCell>
                    <TableCell>February 15</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/kansas-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Kansas (KS)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/kentucky-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Kentucky (KY)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/louisiana-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Louisiana (LA)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/maine-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Maine (ME)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/maryland-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Maryland (MD)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/massachusetts-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Massachusetts (MA)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/michigan-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Michigan (MI)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/minnesota-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Minnesota (MN)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/mississippi-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Mississippi (MS)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/missouri-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Missouri (MO)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/montana-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Montana (MT)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/nebraska-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Nebraska (NE)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Nevada (NV)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>New Hampshire (NH)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/new-jersey-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        New Jersey (NJ)
                      </Link>
                    </TableCell>
                    <TableCell>February 15</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/new-mexico-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        New Mexico (NM)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>New York (NY)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>
                      State Tax Exists but No Filing Required
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/north-carolina-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        North Carolina (NC)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/north-dakota-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        North Dakota (ND)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/ohio-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Ohio (OH)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/oklahoma-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Oklahoma (OK)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/oregon-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Oregon (OR)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/pennsylvania-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Pennsylvania (PA)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>

                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/rhode-island-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Rhode Island (RI)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/south-carolina-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        South Carolina (SC)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>South Dakota (SD)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Tennessee (TN)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Texas (TX)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/utah-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Utah (UT)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/vermont-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Vermont (VT)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/virginia-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Virginia (VA)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Washington (WA)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>
                      {' '}
                      <Link
                        href="/form-w2-state-filing/west-virginia-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        West Virginia (WV)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>Filing Required Only If Withholding</TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>
                      <Link
                        href="/form-w2-state-filing/wisconsin-w-2-filing-requirements/"
                        sx={{ color: '#0202ff' }}
                      >
                        Wisconsin (WI)
                      </Link>
                    </TableCell>
                    <TableCell>January 31</TableCell>
                    <TableCell>
                      Filing is mandatory, regardless of any withholdings.
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Wyoming (WY)</TableCell>
                    <TableCell>No Filing Required</TableCell>
                    <TableCell>No State Tax</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Why Choose TaxZerone?
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            sx={{ justifyContent: 'center' }}
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy W-2 Generation"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy W-2 Generation
                </Typography>
                <Typography variant="body1">
                  Create accurate W-2 forms in minutes with our intuitive
                  platform. Input employee data easily, review, and generate
                  forms without hassle, saving you time and effort.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-rule-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-rule-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-rule-icon.png"
                      alt="State Compliance Checks"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  State Compliance Checks
                </Typography>
                <Typography variant="body1">
                  Our system ensures your W-2 forms meet all state-specific
                  regulations. Stay compliant and avoid penalties with automatic
                  checks tailored to your location.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/time-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/time-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/time-icon.png"
                      alt="E-Filing Options"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  E-Filing Options
                </Typography>
                <Typography variant="body1">
                  Quickly file W-2 forms electronically, ensuring timely
                  submission. Benefit from real-time tracking and confirmations,
                  so you can file confidently and meet all deadlines without
                  stress.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Dedicated Support
                </Typography>
                <Typography variant="body1">
                  Access our responsive support team for any questions during
                  the filing process. We also provide valuable resources and
                  guides to help you navigate W-2 filing with ease.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Data Security"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Data Security
                </Typography>
                <Typography variant="body1">
                  We prioritize your data security with advanced encryption and
                  protection measures. Trust us to keep your sensitive
                  information safe while you focus on your business.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Choose TaxZerone for a reliable, efficient W-2 filing experience!
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            lineHeight: 1.5,
            mb: 3,
          }}
        >
          Ready to Ensure Compliance?
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=w-2state-filing`}
          >
            E-File Form W-2
          </Button>
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. What are W-2 state filing requirements, and why are they
                  important?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    W-2 state filing requirements are the regulations each U.S.
                    state sets for employers to report wages and tax information
                    for their employees. These rules are crucial to ensure
                    compliance, avoid penalties, and keep employee tax records
                    accurate for correct tax returns and refunds.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. Do all states require the filing of W-2 forms?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    <b> No</b>, not all states require the filing of W-2 forms.
                    Some states like Alaska, Florida, and Texas do not require
                    filing due to the absence of state income tax. Others, such
                    as California and New York, have state tax but do not
                    mandate W-2 form filing.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. What is the deadline for filing W-2 forms for most states?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    For most states, the deadline for filing W-2 forms is
                    January 31. However, exceptions include New Jersey and Iowa,
                    where the deadline extends to <b>February 15</b>.
                  </Typography>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. What are the key differences in W-2 filing requirements
                  across states?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text" sx={{ mt: 1 }}>
                    Different states have unique W-2 filing requirements,
                    including specific deadlines, mandatory electronic filing,
                    and conditions related to state tax withholding. Employers
                    need to understand these variations to ensure compliance.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Index;
